import SeamApi from '../lib/seam-api';

const legacyTeamIds = {
    'programmes/launchpad': 1,
    'programmes/tech-welcome': 5,
    'programmes/business-productivity': 10,
    'programmes/rural-grant': 11,
    'programmes/low-carbon': 12,
};

const getAdminTeamMap = async () => {
    try {
        const { data } = await SeamApi.get('/api/admin-teams/programme-map', { params: {} });
        return data || {};
    } catch (error) {
        return {};
    }
};

const getAdminTeamId = async (...slugs) => {
    const adminTeamMap = await getAdminTeamMap();

    for (const slug of slugs) {
        if (!slug) continue;

        if (adminTeamMap[slug] !== undefined) {
            return adminTeamMap[slug];
        }

        if (legacyTeamIds[slug] !== undefined) {
            return legacyTeamIds[slug];
        }
    }

    return 6;
};

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('enquire-form');

    const disableForm = () => {
        form.classList.add('form--completed')

        Array.from(form.elements).forEach(formElement => formElement.disabled = true);
    }

    if (form) {
        form.addEventListener('submit', async (event) => {
            const email = document.getElementById('enquire-email');
            const first_name = document.getElementById('enquire-first-name');
            const last_name = document.getElementById('enquire-last-name');
    
            const error = document.getElementById('enquire__error');
            const mailingList = document.getElementById('remember-mailing');
            const phone = document.getElementById('enquire-phone');
            const message = document.getElementById('enquire-message');

            const slug = form.getAttribute('data-slug');
            const type = form.getAttribute('data-type');
    
            let params = {
                source_distribution_id : 1,
                subject: slug,
                message: message?.value || 'Programme Page',
                contact_permissions : [],
                email: email?.value,
                first_name: first_name?.value,
                last_name: last_name?.value,
                phone_number: phone?.value,
            };

            params.admin_team_id = await getAdminTeamId(type, slug);
    
            if (mailingList?.checked === true) params.contact_permissions.push(1);
    
            SeamApi.contacts().message(params, (err) => {
                if (err.hasOwnProperty('email')) {
                    email.classList.toggle('border-gray-300');
                    email.classList.add('border-red-400');
                }
                
                error.innerText = 'There seems to have been an error';
                error.className = 'text-sm font-medium text-red-500';
             }).then(() => {
                error.innerText = 'Successfully enquired! You will hear back shortly';
                error.className = 'text-sm font-medium text-green-500';

                disableForm();
             });
    
            event.preventDefault();
        })
    }
});